import React from 'react';
import PropTypes from 'prop-types';
import format from 'date-fns/format';
import CommentIcon from 'components/atoms/icons/commentIcon';
import CheckIcon from 'components/atoms/icons/doubleCheckIcon';
import common from 'constants/common';

const CommentItem = ({ comment }) => (
  <div className="activity-comments-item">
    <div className="comment-header">
      <strong>
        {comment.createdByTitle} {comment.createdByFirstName}{' '}
        {comment.createdByLastName}
        {comment.createdByProfessionType ? ' - ' : ' '}
        {comment.createdByProfessionType}
      </strong>
      <div className="comment-header-checked">
        <p>{format(new Date(comment.createdAt), common.dateFormats.full)}</p>
        {comment.reviewed && <CheckIcon />}
      </div>
    </div>
    <div className="comment-body">
      <CommentIcon />
      <span>{comment.message}</span>
    </div>
  </div>
);

CommentItem.propTypes = {
  comment: PropTypes.shape().isRequired,
};

export default CommentItem;
